module.exports = __webpack_public_path__ + "static/logo-Cargolink-white-3319a34e7cb6a7c47d6a75fdd04e329c.png";